import {_import_} from './_import.js';
const url = 'growupLine'; // 模块文件夹路径
const growupLine = _import_(url + '/index');

export default [
  {
    path: '/growupLine',
    name: 'growupLine',
    meta: {
      title: {title: '成长曲线', color: '#ffffff'},
      needLogin: true
    },
    component: growupLine
  }
];



// WEBPACK FOOTER //
// ./src/router/growupLine.js